export default __webpack_public_path__ + "static/media/12.ae4713f2.jpg";